import { useEffect,lazy,Suspense } from 'react';
import { Edit } from '@mui/icons-material';
import axios from 'axios';
import toastr from 'toastr';
import {BrowserRouter as Router,Routes,Route, Navigate,Link as RouterLink, useLocation, useNavigate} from "react-router-dom";
import logo from './logo.svg';
import './App.css';
import "toastr/build/toastr.min.css";
import { CircularProgress } from '@mui/material';
import ShowFollowers from './pages/showDetails/showFollowers';



// import Navbar  from './components/navbar'
const Navbar = lazy(()=> import ('./components/navbar'))
const PersonForm = lazy(()=> import ('./pages/formPages/personForm'))
const AdminManageRQuery = lazy(()=> import ('./pages/adminManagement/adminManageRQuery'))
const TablePageOne = lazy(()=> import ('./pages/adminManagement/tablePageOne'))
const MultiForm = lazy(()=> import ('./pages/formPages/multiForm'))
const RoleManageForm = lazy(()=> import ('./pages/formPages/roleManageForm'))
const UserManagement = lazy(()=> import ('./pages/userManagement/userManagement'))
const ShowDetails = lazy(()=> import ('./pages/showDetails/showDetails'))
const UserEditForm = lazy(()=> import ('./pages/formPages/userEditForm'))
const Login = lazy(()=> import ('./pages/formPages/loginForm'))
const SubmitOTP = lazy(()=> import ('./pages/formPages/submitOTP'))
const ChangePassword = lazy(()=> import ('./pages/formPages/changePassword'))
const CourseManagement = lazy(()=> import ('./pages/courseManagement/courseManagement'))
const CourseDetailContainer = lazy(()=> import ('./pages/courseManagement/courseFormContainer'))
const CourseDetailForm = lazy(()=> import ('./pages/formPages/courseForms/courseDetails'))
const CourseDescriptionForm = lazy(()=> import ('./pages/formPages/courseForms/description'))
const CourseSpeakerProfileForm = lazy(()=> import ('./pages/formPages/courseForms/speakerProfile'))
const CourseResourcesForm = lazy(()=> import ('./pages/formPages/courseForms/resources'))
const CourseFAQForm = lazy(()=> import ('./pages/formPages/courseForms/fAQ'))
const CourseSyllabusForm = lazy(()=> import ('./pages/formPages/courseForms/syllabus'))
const CourseAdditionalForm = lazy(()=> import ('./pages/formPages/courseForms/addtional'))
const ViewCountDetails = lazy(()=> import ('./pages/showDetails/viewCountDetails'))
const UniqueViewsDetails = lazy(()=> import ('./pages/showDetails/uniqueViewsDetails'))
const EnrolledUsersDetails = lazy(()=> import ('./pages/showDetails/enrolledUsersDetails'))
const CourseSubDetails = lazy(()=> import ('./pages/showDetails/courseSubDetails'))
const CourseDashboard = lazy(()=> import ('./pages/showDetails/courseDashboard'))
const PayoutManagement = lazy(()=> import ('./pages/payoutManagement/payoutManagement'))
const AccessDenied = lazy(()=> import ('./pages/accesDeniedPage/accessDenied'))
const CouponManage = lazy(()=> import ('./pages/couponManagement/couponManage'))
const CouponForm = lazy(()=> import ('./pages/formPages/couponForm'))
const TablePageOneOffline = lazy(()=> import ('./pages/adminManagement/tablePageOneOffline'))
const ActiveUsersManagement = lazy(()=> import ('./pages/activeUsersManagement/activeUsersManage'))
const AdminDashboardLogin = lazy(()=> import ('./pages/formPages/adminDashboardLogin'))
const DownloadEnrollDetails = lazy(()=> import ('./pages/downloadEnrollDetails/downloadEnrolDetails'))
const CampaignManagement = lazy(()=> import ('./pages/campaignPage/campaignManagement'))
const VideoAnalytic = lazy(()=> import ('./pages/videoAnalytics/videoAnalytic'))
const DownloadEventMange = lazy(()=> import ('./pages/downloadEventDetails/downloadEventMange'))
const OrganiserManage = lazy(()=> import ('./pages/organiserManagement/organiserManage'))
const OrganiserEventManage = lazy(()=> import ('./pages/organiserManagement/organiserEventManage'))
const EventAdminForm = lazy(()=> import ('./pages/formPages/eventForms/eventAdminForm'))
const WelcomeDashboard = lazy(()=> import ('./pages/welcomeDashboard/welcomeDashboard'))
const EventTablePage = lazy(()=> import ('./pages/eventManagement/eventManageTable'))
const ForgatePasswordForm = lazy(()=> import ('./pages/formPages/forgatePasswordForm'))
const CustomNotificationManage = lazy(()=> import ('./pages/notificationManagement/customNotificationManage'))
const ScheduleNotificationManage = lazy(()=> import ('./pages/notificationManagement/scheduleNotificationManagement'))
const UserMergeManage = lazy(()=> import ('./pages/userMergeManagement/userMergeManage'))
const UserMergeForm = lazy(()=> import ('./pages/userMergeManagement/userMergeForm'))
const EventFormContainer = lazy(()=> import ('./pages/eventManagement/eventFormContainer'))
const EventDetailForm = lazy(()=> import ('./pages/formPages/eventForms/detailsForm'))
const NotificationForm = lazy(()=> import ('./pages/formPages/notificationForm'))
const ContactForm = lazy(()=> import ('./pages/formPages/eventForms/contactForm'))
const CommitteeForm = lazy(()=> import ('./pages/formPages/eventForms/committeeForm'))
const AboutForm = lazy(()=> import ('./pages/formPages/eventForms/aboutForm'))
const AgendaForm = lazy(()=> import ('./pages/formPages/eventForms/agendaForm'))
const AgendaSubFormContainer = lazy(()=> import ('./pages/eventManagement/agendaSubFormContainer'))
const WorkshopForm = lazy(()=> import ('./pages/formPages/eventForms/agendaEventSubForm/workshopForm'))
const CmeForm = lazy(()=> import ('./pages/formPages/eventForms/agendaEventSubForm/cmeForm'))
const ConferenceForm = lazy(()=> import ('./pages/formPages/eventForms/agendaEventSubForm/conferenceForm'))
const AbstractForm = lazy(()=> import ('./pages/formPages/eventForms/agendaEventSubForm/abstractsForm'))
const PartnerForm = lazy(()=> import ('./pages/formPages/eventForms/partnerForm'))
const RoomForm = lazy(()=> import ('./pages/formPages/eventForms/roomsForm'))
const FeesForm = lazy(()=> import ('./pages/formPages/eventForms/feesForm'))
const FeesSubFormContainer = lazy(()=> import ('./pages/eventManagement/feesSubFormContainer'))
const WorkShopFees = lazy(()=> import ('./pages/formPages/eventForms/feesSubForms/workshopFees'))
const ConferenceFeesForm = lazy(()=> import ('./pages/formPages/eventForms/feesSubForms/conferenceForm'))
const OtherFeesForm = lazy(()=> import ('./pages/formPages/eventForms/feesSubForms/otherForm'))
const EventAdditionalForm = lazy(()=> import ('./pages/formPages/eventForms/eventAdditionalForm'))
const SpeakersForm = lazy(()=> import ('./pages/formPages/eventForms/SpeakersForm'))
const ShuttleForm = lazy(()=> import ('./pages/formPages/eventForms/shuttleForm'))
const VenueForm = lazy(()=> import ('./pages/formPages/eventForms/venueForm'))
const ToursForm = lazy(()=> import ('./pages/formPages/eventForms/toursForm'))
const TravelForm = lazy(()=> import ('./pages/formPages/eventForms/travelForm'))
const EventFilter = lazy(()=> import ('./pages/eventFilterManagement/eventFilter'))
const EventVideoMapping = lazy(()=> import ('./pages/eventVideoMapping/eventVideoMapping'))
const CommentsSubDetails = lazy(()=> import ('./pages/showDetails/commentShowDetals'))
const LiveEventManagement = lazy(()=> import ('./pages/liveEventManagement/liveEventManagement'))
const EventDashboard = lazy(()=> import ('./pages/showDetails/eventDashboard'))
const PostAnActivity = lazy(()=> import ('./pages/formPages/eventForms/postAnActivity/postAnActivity'))
const CertificateManagement = lazy(()=> import ('./pages/cmeCertificateManagement/certificateManagement'))
const EmailControls = lazy(()=> import ('./pages/emailControlsManagement/emailControls'))
const PackagePage = lazy(()=> import ('./pages/PackagePageManagement/PackagePage'))
const PackageForm = lazy(()=> import ('./pages/formPages/PackageForm'))
const SubscriptionDetailsPage = lazy(()=> import ('./pages/subscriptionDetailsManagement/subscriptionDetailsPage'))
const SubscriptionDetailsForm = lazy(()=> import ('./pages/formPages/subscriptionDetailsForm'))
const TempSubsCollectionPage = lazy(()=> import ('./pages/formPages/tempSubsCollectionPage'))
const LiveCourseManagement = lazy(()=> import ('./pages/courseManagement/liveCourseManagement'))
const SpeakerManagementPage = lazy(()=> import ('./pages/speakerManagement/speakerManagement'))
const SpeakerDetailsForm = lazy(()=> import ('./pages/formPages/speakerDetailsForm'))
const TransactionManagement = lazy(()=> import ('./pages/transactionMangement/transactionMangement'))
// const VideoConverter = lazy(()=> import ('./pages/videoConverter/VideoConverter'))
const CountryManagementPage = lazy(()=> import ('./pages/countryManagement/countryManagement'))
const CountryForm = lazy(()=> import ('./pages/formPages/countryForm'))

function App() {

  axios.defaults.withCredentials= true
  axios.defaults.credentials= 'include'

  useEffect(()=>{
    toastr.options={
      "progressBar": true,
      "positionClass":"toast-top-right",
      "showDuration":"150"
  }
 //console.log(process.env.REACT_APP_SECRET_KEY);
 //console.log(process.env.REACT_APP_API_LINK);
  },[])

  return (
    <div className="App">
      <Router>
        <Suspense fallback={<CircularProgress/>}>
        <Routes>
          
          {/* outlet is in navbar component in .view-page .view */}
          
          <Route path="/login"  exact element={<Login/>}/>
          <Route path="/dashboard-login/:type/:courseId"  exact element={<AdminDashboardLogin/>}/>
          <Route path="/forgot-password"  exact element={<ForgatePasswordForm key="forgotPassword"/>}/>
          <Route exact path="/guest-form" element={<MultiForm/>}/>
          <Route exact path="/submit-otp" element={<SubmitOTP/>}/>
          <Route exact path="/change-password" element={<ChangePassword/>}/>
          <Route exact path="/course-dashboard/:courseId" key="dashboard" element={<CourseDashboard/>}/>
          <Route exact path="/event-dashboard/:courseId" key="dashboard" element={<EventDashboard/>}/>
          <Route exact path="total-registrations" element = {<TablePageOneOffline
             key='total-registrations'
             pageTitle={"Existing users"}
             dBFields={[
              {name:'Name',value:"fullname"},
              {name:'Email id',value:"email"},
              {name:'Mobile No.',value:"mobileno"},
              {name:'Date',value:"whenentered"},
              // {name:'Time',value:"email"},
              
            ]}
               formLink={"/form"}
              showTableFeatures={true}
              showDownloadBtn={true}
              showSearchBar={false}
              showAddBtn={false}
              showSortOrder={true}
              downloadOffline = {true}
              showTotal={false}
			  
             />}/>
          
          <Route path="/" exact element={<Navigate to="/login" state={{title:'Admin Login',dBFields:[{name:"Email id",value:"emailId"},{name:"password",value:"password",fieldType:"password"}],apiPOSTLink:"",apiPATCHLink:""}}/>}/>
          <Route exact path='subscollectioncount' element={<TempSubsCollectionPage />} />
          <Route path="/" exact element={<Navbar/>}>
           <Route path="dashboard" exact element={<WelcomeDashboard />} />
            {/* <Route path="admin-management" element={<AdminManage/>}/> */}
             
            <Route exact path="admin-management-r-query" element={<AdminManageRQuery/>}/>
            <Route  exact path="admin-management" element={
              <TablePageOne
              key="admin-management"
              downloadXlsxFileName="admin_details"
              pageTitle={'Admin Management'} 
              apiGETLink={`${process.env.REACT_APP_API_LINK}/admin/getAdmins`}
              apiPATCHLink={`${process.env.REACT_APP_API_LINK}`}
              apiActiveLiink={`${process.env.REACT_APP_API_LINK}/admin/Adminactivedeactive`}
              linkPageTitle={'Admin Management'}
              dBFields={
              
                [{name:'Created on',value:"whenentered",show:false},
                  {name:'First name',value:"firstName"},
              {name:'Last name',value:"lastName"},
              {name:"Email id", value:"emailId"},
              {name:"Mobile number", value:"mobileNumber"},
              {name:"Roles", value:"roles",valueKey:"roleName"},
              ]}
              formLink={"/person-form"}
              showAction={true}
              
              
              />}
             />
            
            <Route  exact path="active-users-management" element={
             <ActiveUsersManagement
             key="active-users-management"
                  pageTitle={'Active users'} 
                  apiGETLink={`${process.env.REACT_APP_API_LINK}/admin/getactiveusermaster`}
                  apiPATCHLink={`${process.env.REACT_APP_API_LINK}`}
                  linkPageTitle={'admin'}
                  dBFields={
                    [
                      {name:'Date',value:"date"},
                      {name:'Active users',value:"LoginDetails"},
                  
                  ]}
                  formLink={"/person-form"}
                  showAction={true}
                  showSearchBar = {false}
                  showTableFeatures={false}
                  showTableDeactivateBtn = {false}
                  showTableEditBtn = {false}
                  showDownloadBtn={false}
              
                  
             />}
             />

            <Route exact path="total-registrations-admin" element = {<TablePageOneOffline
             key='total-registrations'
             downloadXlsxFileName={"Existing_users"}
             pageTitle={"Existing users"}
             dBFields={[
              {name:'Name',value:"fullname"},
              {name:'Email id',value:"email"},
              {name:'Mobile No.',value:"mobileno"},
              {name:'Date',value:"whenentered"},
              // {name:'Time',value:"email"},
              
            ]}
              formLink={"/form"}
              showTableFeatures={true}
              showDownloadBtn={true}
              showSearchBar={false}
              showAddBtn={false}
              showSortOrder={true}
              downloadOffline = {true}
              showTotal={false}
             />}/>


            <Route  exact path="page-management" element={<TablePageOne
            key="page-management"
            downloadXlsxFileName="page_details"
            pageTitle={'Page Management'}
            apiGETLink={`${process.env.REACT_APP_API_LINK}/admin/getPages`}
            apiPATCHLink={`${process.env.REACT_APP_API_LINK}/admin/updatePage`}
            apiPOSTLink={`${process.env.REACT_APP_API_LINK}/admin/addPage`}
            apiActiveLiink={`${process.env.REACT_APP_API_LINK}/admin/pagemangactivedeactive`}
            linkPageTitle={'page manage'}
            dBFields={[
              {name:'Module name',value:"moduleName",formError:"please fill in module name"},
              {name:'Module link',value:"moduleLink",formError:"please fill in module link"},
              {name:'Main menu name',value:"mainMenuName",formError:"please fill in main menu name"},
              {name:'Sub menu name',value:"subMenuName",formError:"please fill in sub menu name"},
              
            ]}
            formLink={"/form"}
            showAction={true}
            // showTableEditBtn={false}
            />}/>
            

     
            <Route  exact path="role-management" element={<TablePageOne
            key="role-management"
            downloadXlsxFileName="role_details"
            pageTitle={'Role Management'}
            apiGETLink={`${process.env.REACT_APP_API_LINK}/admin/getRoles`}
            apiPATCHLink={`${process.env.REACT_APP_API_LINK}/admin/updateRole`}
            apiPOSTLink={`${process.env.REACT_APP_API_LINK}/admin/addRole`}
            apiActiveLiink={`${process.env.REACT_APP_API_LINK}/admin/rolemangeactivedeactive`}
            linkPageTitle={'role manage'}
            dBFields={[
              {name:'Created on',value:"whenentered",show:false},
              {name:'Role name',value:"roleName",type:'textbox',formError:"please fill in role name"},
              {name:'Access rights',value:"moduleLinks",type:'checkbox',formError:"please choose atleast one access "},
            ]}
            formLink={"/role-management-form"}
            showAction={true}
            // showTableEditBtn={false}
            />}/>

            <Route  exact path="interest-management" element={<TablePageOne
            key="interest-management"
            downloadXlsxFileName="interest_details"
            pageTitle={'Interest Management'}
            apiGETLink={`${process.env.REACT_APP_API_LINK}/admin/getInterests`}
            apiPATCHLink={`${process.env.REACT_APP_API_LINK}/admin/updateInterest`}
            apiPOSTLink={`${process.env.REACT_APP_API_LINK}/admin/addInterest`}
            apiActiveLiink={`${process.env.REACT_APP_API_LINK}/admin/updateInterestIsActive`}
            linkPageTitle={'interest manage'}
            dBFields={[
              { name: "Created on", value: "whenentered",show:false,editAllow:false},
              {name:'Interest name',value:"interests",formError:"please fill in interest name"},
              
            ]}
            formLink={"/form"}
            showAction={true}
            // showTableEditBtn={false}
            />}/>

            <Route  exact path="qualifcation-management" element={<TablePageOne
            key="qualifcation-management"
            downloadXlsxFileName="qualification_details"
            pageTitle={'Qualifcation Management'}
            apiGETLink={`${process.env.REACT_APP_API_LINK}/admin/getQualifications`}
            apiPATCHLink={`${process.env.REACT_APP_API_LINK}/admin/updateQualification`}
            apiPOSTLink={`${process.env.REACT_APP_API_LINK}/admin/addQualification`}
            apiActiveLiink={`${process.env.REACT_APP_API_LINK}/admin/updateQualificationIsActive`}
            linkPageTitle={'qualification manage'}
            dBFields={[
              { name: "Created on", value: "whenentered",show:false,editAllow:false},
              {name:'Qualification name',value:"Abbreviation",formError:"please fill in qualification name"},
              {name:'Description',value:"fullDescription",formError:"plz fill in qualification description"},
              
            ]}
            formLink={"/form"}
            showAction={true}
            // showTableEditBtn={false}
            />}/>
           
            <Route  exact path="practiceas-management" element={<TablePageOne
            key="practiceas-management"
            downloadXlsxFileName="practiceas_details"
            pageTitle={'Practice As Management'}
            apiGETLink={`${process.env.REACT_APP_API_LINK}/admin/getPracticeAs`}
            apiPATCHLink={`${process.env.REACT_APP_API_LINK}/admin/updatePracticeAs`}
            apiPOSTLink={`${process.env.REACT_APP_API_LINK}/admin/addPracticeAs`}
            apiActiveLiink={`${process.env.REACT_APP_API_LINK}/admin/updatePracticeAsIsActive`}
            linkPageTitle={`practice manage`}
            dBFields={[
              { name: "Created on", value: "whenentered",show:false,editAllow:false},
              {name:'Practice As name',value:"expertise",formError:"please fill in practice name"},
              
            ]}
            formLink={"/form"}
            showAction={true}
            // showTableEditBtn={false}
            />}/>

           <Route  exact path="filter-management" element={<TablePageOne
            key="filter-management"
            downloadXlsxFileName="filter_details"
            pageTitle={'Filter Management'}
            apiGETLink={`${process.env.REACT_APP_API_LINK}/event/getEventfilter`}
            apiPATCHLink={`${process.env.REACT_APP_API_LINK}/event/updateEventfilter`}
            apiPOSTLink={`${process.env.REACT_APP_API_LINK}/event/addEventfilter`}
            apiActiveLiink={`${process.env.REACT_APP_API_LINK}/event/updateEventfilterIsActive`}
            linkPageTitle={'filter manage'}
            dBFields={[
              {name:'Filter name',value:"filtername",formError:"please fill in interest name"},
            ]}
            formLink={"/form"}
            showAction={true}
            showDownloadBtn={false}
            // showTableEditBtn={false}
            />}/>
            
<Route  exact path="coupon-management" element={<CouponManage
            key="coupon-management"
            downloadXlsxFileName="coupon_details"
            pageTitle={'Coupon Management'}
            apiGETLink={`${process.env.REACT_APP_API_LINK}/admin/getCouponManage`}
            apiPATCHLink={`${process.env.REACT_APP_API_LINK}/admin/updatecoupon/:id`}
            apiPOSTLink={`${process.env.REACT_APP_API_LINK}/admin/addCouponManage`}
            apiActiveLiink={`${process.env.REACT_APP_API_LINK}/admin/updateCouponcodeIsActive`}
            linkPageTitle={`coupon manage`}
            formLink={"/coupon-form"}
            showAction={true}
            showAddBtn={true}
            showDownloadBtn={true}
            showTotal={true}
            
           
            // showTableEditBtn={false}
            />}/>

{/* <Route  exact path="video-converter" element={<VideoConverter/>}/>  */}

<Route  exact path="course-management" element={<CourseManagement 
          key="course-management"
          downloadXlsxFileName="course_details"
          pageTitle={'Video Management'}
          apiGETLink={`${process.env.REACT_APP_API_LINK}/admin/getCourses`}
          apiPATCHLink={`${process.env.REACT_APP_API_LINK}/admin/updateCourse`}
          apiPOSTLink={`${process.env.REACT_APP_API_LINK}/admin/addPage`}
          apiActiveLiink={`${process.env.REACT_APP_API_LINK}/admin/updateCourseIsActive`}
          linkPageTitle={`course manage`}
          formLink={"/course-form/course-details"}
          showAction={true}
          showAddBtn={true}
          showTableDeactivateBtn={true}
          // showTableDetailsBtn={true}
          showTableEditBtn={true}
          showDownloadBtn={true}
          showTotal={true}
          showSyncBtn={true}
        
/>}/>

 {/* Event Routing start from here */}

<Route  exact path="event-management" element={<EventTablePage
          key="event-management"
          downloadXlsxFileName="event_details"
          pageTitle={'Event Management'}
          apiGETLink={`${process.env.REACT_APP_API_LINK}/event/getEvents`}
          apiPATCHLink={`${process.env.REACT_APP_API_LINK}/event/getEvents`}
          // apiPOSTLink={`${process.env.REACT_APP_API_LINK}/event/getEvents`}
          apiActiveLiink={`${process.env.REACT_APP_API_LINK}/event/updateEventIsActive`}
          linkPageTitle={`Event manage`}
          formLink={"/event-form/details"}
          showAction={true}
          showAddBtn={true}
          showTableDeactivateBtn={true}
          // showTableDetailsBtn={true}
          showTableEditBtn={true}
          showDownloadBtn={true}
          showTotal={true}
        
/>}/>

<Route  exact path="livecourse-management" element={<LiveCourseManagement
          key="livecourse-management"
          downloadXlsxFileName="livecourse"
          pageTitle={'Live Course Management'}
          apiGETLink={`${process.env.REACT_APP_API_LINK}/admin/getLiveCourseData`}
          apiPATCHLink={`${process.env.REACT_APP_API_LINK}/admin/updateLiveCourseData`}
      
          linkPageTitle={`live course`}
          formLink={"/livecourse"}
          dBFields = {
            [
              { name: "coursename", value: "coursename",isSearch:false,isSort:true}, 
              { name: "sectionname", value: "sectionname", isSearch:false,isSort:false },
              { name: "videotitle", value: "videotitle", isSearch:false ,isSort:false},
        
            ]
          }
          showAction={true}
          showAddBtn={false}
          showTableDeactivateBtn={false}
          showTableEditBtn={false}
          showTableViewBtn={false}
          showDownloadBtn={false}
          showTotal={true}
        
/>}/>

<Route  exact path="country-management" element={<CountryManagementPage
            key="country-management"
            downloadXlsxFileName="country"
            pageTitle={'Country Management'}
            apiGETLink={`${process.env.REACT_APP_API_LINK}/country/getCountry`}
            apiPATCHLink={`${process.env.REACT_APP_API_LINK}/country/updateCountry`}
            apiPOSTLink={`${process.env.REACT_APP_API_LINK}/country/addCountry`}
            apiActiveLiink={`${process.env.REACT_APP_API_LINK}/country/updateCountryIsActive`}
            linkPageTitle={'Country Manage'}
            dBFields={[
              { name: "Created on", value: "whenentered",fieldType:"date",show:true,editAllow:false,isSearch:false,isSort:false},
              // {name:'Qualification name',value:"Abbreviation",formError:"please fill in qualification name"},
              {name:'Country',value:"Country"},
              {name:'Country Code',value:"Code",isSearch:false,isSort:false},
              {name:'Currency Code',value:"currencycode",isSearch:false,isSort:false},
              {name:'Exchange Rate',value:"exchangerate",isSort:false,isSearch:false,},
              {name:'Mobile Code',value:"mobilecode",isSort:false,isSearch:false,},
              {name:'Currency Symbol',value:"currSymbol",isSort:false,isSearch:false,},
              {name:'Substantial Discount',value:"diffprice",isSort:false,isSearch:false,},
              { name: "Modified On", value: "whenmodified",fieldType:"date",show:true,editAllow:false,isSearch:false,isSort:false},
              
            ]}
            formLink={"/country-form"}
            showAction={true}
            showTableDeactivateBtn={true}
            showSyncBtn = {true}
            // showTableEditBtn={false}
            />}/>

<Route exact path="event-filter" element={<EventFilter/>}/>
<Route exact path="event-video-mapping" element={<EventVideoMapping/>}/>

<Route exact path="event-form" element={<EventFormContainer/>}>
<Route exact path="details" element={<EventDetailForm/>}/>
<Route exact path="contact" element={<ContactForm/>}/>
<Route exact path="committee" element={<CommitteeForm/>}/>
<Route exact path="about" element={<AboutForm/>}/>
<Route exact path="partner" element={<PartnerForm/>}/>
<Route exact path="room" element={<RoomForm/>}/>
<Route exact path="venue" element={<VenueForm />}/>
<Route exact path="speakers" element={<SpeakersForm />}/>
<Route exact path="tours" element={<ToursForm />}/>
<Route exact path="travel" element={<TravelForm />}/>
<Route exact path="shuttle" element={<ShuttleForm />}/>
<Route exact path="additional" element={<EventAdditionalForm/>}/>

  {/* agenda sub event froms */}
<Route exact path="agenda" element={<AgendaForm/>}>
<Route exact path="agendaSubevent-form" element={<AgendaSubFormContainer />} />
<Route exact path="workshop" element={<WorkshopForm />} />
<Route exact path="cme" element={<CmeForm />} />
<Route exact path="conference" element={<ConferenceForm />} />
<Route exact path="abstracts" element={<AbstractForm />} />
</Route>
 {/* fees sub event form */}
 <Route exact path="fees" element={<FeesForm/>}>
 <Route exact path="feesSubEventForm" element={<FeesSubFormContainer />} />
 <Route exact path="workshopfees" element={<WorkShopFees />} />
 <Route exact path="conferencefeesform" element={<ConferenceFeesForm />} />
 <Route exact path="otherfeesform" element={<OtherFeesForm />} />
 </Route>
</Route> 

{/* Event Routing end from here */}

<Route  exact path="organiserevent-management" element={<OrganiserEventManage
            key="organiserevent-management"
            downloadXlsxFileName="organiserevent_details"
            pageTitle={'Event By -'}
            linkPageTitle={`organiserevent`}
           
             dateFilter={true}
           
             showSearchBar = {true}
            
            />}/>

           <Route  exact path="video-analytic" element={<VideoAnalytic
            key="video-analytic"
            pageTitle={'Video Analytics'}
            linkPageTitle={`videoAnalytic`}
            showDownloadBtn={false}
            showTotal={true}
            // showAction={true}
            // showAddBtn={true}
             // showTableEditBtn={false}
            
            
           
            // showTableEditBtn={false}
            />}/>
          

          <Route  exact path="campaign-analytics" element={<CampaignManagement
            key="campaign-management"
            downloadXlsxFileName="campaign_details"
            pageTitle={'Campaign Analytics'}
            linkPageTitle={`campaign`}
            showDownloadBtn={false}
            showTotal={true}
            // showAction={true}
            // showAddBtn={true}
             // showTableEditBtn={false}
            
            
           
            // showTableEditBtn={false}
            />}/>

<Route  exact path="subscription-management" element={<SubscriptionDetailsPage
            key="subscription-management"
            downloadXlsxFileName="subscription-management"
            pageTitle={'Subscription Management'}
            apiPOSTLink={`${process.env.REACT_APP_API_LINK}/admin/addSubscriptionsDetails`}
            apiGETLink={`${process.env.REACT_APP_API_LINK}/admin/getSubscriptionsDetails`}
            apiPATCHLink={`${process.env.REACT_APP_API_LINK}/admin/updateSubscriptionsDetails`}
            linkPageTitle={'Subscription Manage'}
            dBFields={[
              
              {name:"User Details", value:"packageId",valueKey:"packageName",userDetail:true,isSort:false,isSearch:false},
              // {name:"User Details", value:"userid",valueKey:"fullname",userDetail:true,isSort:false,isSearch:false},
              {name:"Dates", value:"startDate",fieldType:"date",isSort:false,isSearch:false,show:false},
              {name:"Package Details", value:"packageId",valueKey:"packageName",packageDetail:true,isSort:false,isSearch:false},
              {name:"Payment Details", value:"packageId",valueKey:"packageName",paymentDetail:true,isSort:false,isSearch:false},
              {name:"Payment Method", value:"paymentmethod",isSort:false,isSearch:true},
              {name:"Status", value:"status",isSort:true,isSearch:true,show:false},
              {name:"End-Date", value:"endDate",fieldType:"date",isSort:false,isSearch:false,show:false,},
              {name:"Start-Date", value:"startDate",fieldType:"date",isSort:false,isSearch:false,show:false,},
              {name:"Payment ID", value:"pgPaymentId",isSort:false,isSearch:true},
              {name:"Amount Paid", value:"amountpaid",fieldType:"amount",isSort:false,isSearch:false,show:false},
              {name:"Currency Type", value:"currencytype",isSort:false,isSearch:false,show:false,},
              {name:"fullname", value:"fullname",isSort:false,isSearch:true,show:false},
              {name:"email", value:"email",isSort:false,isSearch:true,show:false},
              {name:"mobileno", value:"mobileno",isSort:false,isSearch:true,show:false},
              // {name:"fullname", value:"userid",valueKey:"fullname",show:false,},
              // {name:"email", value:"userid",valueKey:"email",show:false,},
              // {name:"mobileno", value:"userid",valueKey:"mobileno",show:false,},
              {name:"Active", value:"status",valueKey:1,show:false,isSort:false,isSearch:true},
              {name:"Cancelled", value:"status",valueKey:2,show:false,isSort:false,isSearch:true},

            ]}
            formLink={"/subscription-form"}
            showAction={true}
            showTableViewBtn={false}
            showTableEditBtn={true}
            showTableDeactivateBtn={false}
            showAddBtn={true}
            displayOnlySearch={false}
            showDownloadBtn={true}
            showTableFeatures={true}
            showPaymentReminderBtn={true}
            showTotal={true}
            
            />}/>

<Route  exact path="subscription-dashboard" element={<SubscriptionDetailsPage
            key="subscription-dashboard"
            downloadXlsxFileName="subscription-dashboard"
            pageTitle={'Subscription Dashboard'}
            apiPOSTLink={`${process.env.REACT_APP_API_LINK}/subscription/addSubscriptionsDetails`}
            apiGETLink={`${process.env.REACT_APP_API_LINK}/subscription/getSubscriptionsDetails`}
            apiPATCHLink={`${process.env.REACT_APP_API_LINK}/subscription/updateSubscriptionsDetails`}
            linkPageTitle={'Subscription Manage'}
            dBFields={[
              
              {name:"User Details", value:"packageId",valueKey:"packageName",userDetail:true,isSort:false,isSearch:false},
              // {name:"User Details", value:"userid",valueKey:"fullname",userDetail:true,isSort:false,isSearch:false},
              {name:"Dates", value:"startDate",fieldType:"date",isSort:false,isSearch:false,show:false},
              {name:"Package Details", value:"packageId",valueKey:"packageName",packageDetail:true,isSort:false,isSearch:false},
              {name:"Payment Details", value:"packageId",valueKey:"packageName",paymentDetail:true,isSort:false,isSearch:false},
              {name:"Payment Method", value:"paymentmethod",isSort:false,isSearch:true},
              {name:"Status", value:"status",isSort:true,isSearch:true,show:false},
              {name:"End-Date", value:"endDate",fieldType:"date",isSort:false,isSearch:false,show:false,},
              {name:"Start-Date", value:"startDate",fieldType:"date",isSort:false,isSearch:false,show:false,},
              {name:"Payment ID", value:"pgPaymentId",isSort:false,isSearch:false},
              {name:"Amount Paid", value:"amountpaid",fieldType:"amount",isSort:false,isSearch:false,show:false},
              {name:"Currency Type", value:"currencytype",isSort:false,isSearch:false,show:false,},
              {name:"fullname", value:"fullname",isSort:false,isSearch:true,show:false},
              {name:"email", value:"email",isSort:false,isSearch:true,show:false},
              {name:"mobileno", value:"mobileno",isSort:false,isSearch:true,show:false},
              // {name:"fullname", value:"userid",valueKey:"fullname",show:false,},
              // {name:"email", value:"userid",valueKey:"email",show:false,},
              // {name:"mobileno", value:"userid",valueKey:"mobileno",show:false,},
              {name:"Active", value:"status",valueKey:1,show:false,isSort:false,isSearch:false},
              {name:"Cancelled", value:"status",valueKey:2,show:false,isSort:false,isSearch:false},

            ]}
            formLink={"/subscription-form"}
            showAction={true}
            showTableViewBtn={false}
            showTableEditBtn={false}
            showTableDeactivateBtn={false}
            showInvoicBtn={true}
            showAddBtn={false}
            displayOnlySearch={true}
            showDownloadBtn={true}
            showTableFeatures={true}
            showPaymentReminderBtn={true}
            showSortOrder={false}
            showTotal={false}
            
            />}/>

<Route  exact path="speaker-management" element={<SpeakerManagementPage
            key="speaker-management"
            downloadXlsxFileName="speaker"
            pageTitle={'Profile Page Management'}
            apiGETLink={`${process.env.REACT_APP_API_LINK}/speaker/getSpeakerDetails`}
            apiPATCHLink={`${process.env.REACT_APP_API_LINK}/package/updatePackage`}
            apiPOSTLink={`${process.env.REACT_APP_API_LINK}/package/addPackage`}
            apiActiveLiink={`${process.env.REACT_APP_API_LINK}/package/updatePackageIsActive`}
            linkPageTitle={'Speaker Manage'}
            dBFields={[
              { name: "Created on", value: "whenentered",fieldType:"date",show:true,editAllow:false,isSearch:false,isSort:false},
              // {name:'Qualification name',value:"Abbreviation",formError:"please fill in qualification name"},
              {name:'Speaker Name',value:"fullname"},
              {name:'email',value:"email"},
              
             
              
            ]}
            formLink={"/speakerDetails-form"}
            showAction={true}
            showTableDeactivateBtn={false}
            // showTableEditBtn={false}
            />}/>
     
     <Route  exact path="package" element={<PackagePage
            key="package-management"
            downloadXlsxFileName="package"
            pageTitle={'Package Management'}
            apiGETLink={`${process.env.REACT_APP_API_LINK}/package/getPackage`}
            apiPATCHLink={`${process.env.REACT_APP_API_LINK}/package/updatePackage`}
            apiPOSTLink={`${process.env.REACT_APP_API_LINK}/package/addPackage`}
            apiActiveLiink={`${process.env.REACT_APP_API_LINK}/package/updatePackageIsActive`}
            linkPageTitle={'Package Manage'}
            dBFields={[
              { name: "Created on", value: "whenentered",fieldType:"date",show:true,editAllow:false,isSearch:false,isSort:false},
              // {name:'Qualification name',value:"Abbreviation",formError:"please fill in qualification name"},
              {name:'packageName',value:"packageName"},
              {name:'uploadoadminutes',value:"uploadoadminutes",isSearch:false,isSort:false},
              {name:'uploadcountpermonth',value:"uploadcountpermonth",isSearch:false,isSort:false},
              {name:'usertype',value:"usertype",isSort:false,isSearch:false,},
              {name:'Discount',value:"commonDiscount",isSort:false,isSearch:false,},
              {name:'Plan Type',value:"planType",isSort:false,isSearch:false,},
              
            ]}
            formLink={"/package-form"}
            showAction={true}
            showTableDeactivateBtn={true}
            showSyncBtn = {true}
            // showTableEditBtn={false}
            />}/>

            <Route  exact path="download-enrolled-details" element={<DownloadEnrollDetails/>}/>
            <Route path="live-event-management" element={<LiveEventManagement />} />
            <Route  exact path="customNotification-management" element={<CustomNotificationManage />}/>
            <Route  exact path="scheduleNotification-management" element={<ScheduleNotificationManage />}/>
            <Route  exact path="user-merge-management" element={<UserMergeManage />}/>
            <Route exact path="download-event-manage" element={<DownloadEventMange />}/>
            <Route  exact path="user-management" element={<UserManagement/>}/>
            <Route  exact path="organiser-management" element={<OrganiserManage/>}/>
            <Route exact path="subscription-form" element={<SubscriptionDetailsForm/>}/>
            <Route path="payout-management" element={<PayoutManagement/>} />
            <Route path="transaction-management" element={<TransactionManagement/>} />
            <Route path="access-denied" element={<AccessDenied/>} />
            {/* <Route path="coupon-management" element={<CouponManage/>} />   */}
            {/* <Route  exact path="course-management" element={<CourseManagement/>}/> */}
            <Route exact path="/course-admin-dashboard/:courseId" key="course-admin-dashboard" element={<CourseDashboard/>}/>
            
            <Route exact path="/event-admin-dashboard/:courseId" element={<EventDashboard/>}/>
            <Route  exact path="event-dashboard" element={<EventDashboard/>}/>
            <Route exact path="/post-an-activity/:courseId" element={<PostAnActivity />}/>
            <Route exact path="new-email-controls" element={<EmailControls />}/>
            <Route path="course-form" element={<CourseDetailContainer/>}>
           
           
              <Route path='course-details' element={<CourseDetailForm/>}/>
              <Route path='description' element={<CourseDescriptionForm/>}/>
              <Route path='speaker-profile' element={<CourseSpeakerProfileForm/>}/>
              <Route path='resources' element={<CourseResourcesForm/>}/>
              <Route path='faq' element={<CourseFAQForm/>}/>
              <Route path='syllabus' element={<CourseSyllabusForm/>}/>
              
              <Route path='additional-form' element={<CourseAdditionalForm/>}/>
            </Route>
              <Route path="video-unique-users" element={<UniqueViewsDetails/>}/>
            
            {/* this page is also used for edit*/}
            
            <Route exact path="coupon-form" element={<CouponForm />}/>
            <Route exact path="person-form" element={<PersonForm/>}/>
            <Route exact path="role-management-form" element={<RoleManageForm/>}/>
            <Route exact path="userMerge-form" element={<UserMergeForm />}/>
            <Route exact path="form" element={<MultiForm/>}/>
            <Route exact path="show-details" element={<ShowDetails/>}/>
            <Route exact path="user-form" element={<UserEditForm/>}/>
            <Route exact path="view-count" element = {<ViewCountDetails key="view-count"/>}/>
            <Route exact path="/course-comments" element = {<CommentsSubDetails key='comments'/>}/>
            <Route exact path="/user-followers" element = {<ShowFollowers/>}/>
            <Route exact path="/like-counts" element = {<CourseSubDetails key='likecount' />}/>
            <Route exact path="/saved-bookmarks" element = {<CourseSubDetails key='noofbookmarks' />}/>
            <Route exact path="/course-subdetails" element = {<CourseSubDetails/>}/>
			<Route exact path="/enrolled-users" element = {<EnrolledUsersDetails key='enrolled-users'/>}/>
            <Route exact path="/notification-form" element = {<NotificationForm />}/>
            <Route exact path="/package-form" element={<PackageForm/>}/>
            <Route exact path="/country-form" element={<CountryForm/>}/>
            <Route exact path="/speakerDetails-form" element={<SpeakerDetailsForm/>}/>

          {/* event management forms ⬇️*/}
          <Route exact path="/event-admin-form" element ={<EventAdminForm />} />

          {/* certificate management  */}
          <Route exact path="/certificate-management" element ={<CertificateManagement />} />
          </Route>
        </Routes> 
        </Suspense>
      </Router>
     
    </div>
  );
}

export default App;